module.exports = __webpack_public_path__ + "img/Volet roulant solaire avec moustiquaire intégré.27124c46.jpg";